import styles from './FormLabel.module';
export default function FormLabel(props) {
  return (
    <label className={styles.formLabel} {...props}>
      {props.children}
    </label>
  );
}
